<!-- 个人信息查询 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container meinfo-inquire">
      <el-form v-loading="formLoading" size="small" :inline="true" :model="listQuery">
        <!-- 期数-->
        <el-form-item :label="$t('common.periods') + ':'">
          <el-select v-model="listQuery.wWeek" placeholder="" style="width: 120px;">
            <el-option v-for="item in wWeekList" :key="item.wWeek" :label="item.wWeek" :value="item.wWeek"/>
          </el-select>
        </el-form-item>
        <!-- 经销商编号-->
        <el-form-item :label="$t('miMember.memberNo') + ':'">
          <el-input v-model.trim="listQuery.memberNo" :readonly="true" />
        </el-form-item>
        <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
      </el-form>
      <div>
        <div style="display: flex; justify-content: space-around" class="table-top">
          <table class="table-top-left">
            <tr>
              <!-- 基本信息 -->
              <th colspan="2">{{ $t('Common.basicInfomation') }}</th>
            </tr>
            <tr>
              <!-- 经销商编号 -->
              <th>{{ $t('miMember.memberNo') }}</th>
              <td>{{ tableObj.memberNo }}</td>
            </tr>
            <tr>
              <!-- 经销商姓名 -->
              <th>{{ $t('miMember.name') }}</th>
              <td>{{ tableObj.name }}</td>
            </tr>
            <tr>
              <!-- 推荐人编号 -->
              <th>{{ $t('mi.recommendNo') }}</th>
              <td>{{ tableObj.recommendNo }}</td>
            </tr>
            <tr>
              <!-- 推荐人姓名 -->
              <th>{{ $t('miMember.recommendName') }}</th>
              <td>{{ tableObj.tjName }}</td>
            </tr>
            <tr>
              <!-- 安置人编号 -->
              <th>{{ $t('mi.linkNo') }}</th>
              <td>{{ tableObj.linkNo }}</td>
            </tr>
            <tr>
              <!-- 安置人姓名 -->
              <th>{{ $t('mi.linkName') }}</th>
              <td>{{ tableObj.azName }}</td>
            </tr>
          </table>
          <table class="table-top-center">
            <tr>
              <!--卡值级别-->
              <th>{{ $t('Card.value.level') }}</th>
              <td colspan="3">{{ $lt(initDict.LevelType, tableObj.newLevelType) }}</td>
            </tr>
            <!--荣衔级别-->
            <tr>
              <th>{{ $t('mi.honourLevel.id') }}</th>
              <td colspan="3">{{ $lt(initDict.cardType, tableObj.newCardType) }}</td>
            </tr>
            <!--代办处编号-->
            <tr>
              <th>{{ $t('miAgent.agentNo') }}</th>
              <td colspan="3">{{ tableObj.agentNo }}</td>
            </tr>
            <!--加入日期-->
            <tr>
              <th>{{ $t('miMember.joinDate') }}</th>
              <td colspan="3">{{ tableObj.registerDate }}</td>
            </tr>
            <!--当期重消是否活跃-->
            <tr>
              <th>{{ $t('this.current.active') }}</th>
              <td colspan="3">{{ $lt(initDict.status, tableObj.status) }}</td>
            </tr>
            <tr>
              <!--当期网络加入人数-->
              <th rowspan="5">{{ $t('Number.participants') }}</th>
              <td rowspan="5" style="width: 60px;">{{ batchAmountObj.peopleNumSum }}</td>
              <!-- 白金卡 -->
              <th>{{ $t('permit.platinumClass') }}</th>
              <td>{{ batchAmountObj.bjk }}</td>
            </tr>
            <tr>
              <!-- 金卡 -->
              <th>{{ $t('miMember.cardType2') }}</th>
              <td>{{ batchAmountObj.jk }}</td>
            </tr>
            <tr>
              <!-- 银卡 -->
              <th>{{ $t('miMember.cardType1') }}</th>
              <td>{{ batchAmountObj.yk }}</td>
            </tr>
            <tr>
              <!-- 铜卡 -->
              <th>{{ $t('Copper.card') }}</th>
              <td>{{ batchAmountObj.tk }}</td>
            </tr>
            <tr>
              <!-- 未激活 -->
              <th>{{ $t('efubo.card.type1') }}</th>
              <td>{{ batchAmountObj.wjh }}</td>
            </tr>
          </table>
          <table class="table-top-right">
            <tr>
              <!-- 整网累计业绩 -->
              <th rowspan="2">{{ $t('Total.network.performance') }}</th>
              <th class="th-two">USD</th>
              <td>{{ tableObj.pointCa}}</td>
            </tr>
            <tr>
              <th class="th-two">FV</th>
              <td>{{ tableObj.point}}</td>
            </tr>
            <tr>
              <!-- 当期新增整网业绩 -->
              <th rowspan="2">{{ $t('performance.current.period') }}</th>
              <th class="th-two">USD</th>
              <td>{{ tableObj.pointCaAdd}}</td>
            </tr>
            <tr>
              <th class="th-two">FV</th>
              <td>{{ tableObj.pointAdd}}</td>
            </tr>
            <tr>
              <!-- 保留业绩ID及PV -->
              <th rowspan="2">{{ $t('Retain.performance.ID.and.FV') }}</th>
              <th class="th-two">ID</th>
              <td>{{ tableObj.memberNo }}</td>
            </tr>
            <tr>
              <th class="th-two">FV</th>
              <td>{{ tableObj.performanceIdAndPv }}</td>
            </tr>
            <tr>
              <!-- 个人重消累计 -->
              <th rowspan="2">{{ $t('Personal.cumulative') }}</th>
              <th class="th-two">USD</th>
              <td>{{ tableObj.conallSellAmount}}</td>
            </tr>
            <tr>
              <th class="th-two">FV</th>
              <td>{{ tableObj.conallSell}}</td>
            </tr>
            <tr>
              <!-- 当期新增重消 -->
              <th rowspan="2">{{ $t('New.and.cancelled') }}</th>
              <th class="th-two">USD</th>
              <td>{{ tableObj.consumSellAmount}}</td>
            </tr>
            <tr>
              <th class="th-two">FV</th>
              <td>{{ tableObj.consumSell}}</td>
            </tr>
          </table>
        </div>
        <!-- 当期各市场业绩 -->
        <table class="table-footer">
          <thead>
          <!-- 当期各市场业绩 -->
          <tr><th style="text-align: left" colspan="8">{{ $t('Current.market.performance') }}</th></tr>
          <tr>
            <th>{{ $t('common.periods') }}</th>
            <th>{{ $t('bd.marketNo') }}</th>
            <th>{{ $t('bd.marketName') }}</th>
            <th>{{ $t('Cumulative.order.amount.USD') }}</th>
            <th>{{ $t('Cumulative.performance.FV') }}</th>
            <th>{{ $t('New.order.amount.USD') }}</th>
            <th>{{ $t('New.performance.FV') }}</th>
            <th>{{ $t('bd.preCalc') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="v in footerTopList" :key="v.id">
            <td>{{ v.wWeek }}</td>
            <td>{{ v.memberNo }}</td>
            <td>{{ v.name }}</td>
            <td>{{ v.sumamount }}</td>
            <td>{{ v.sumpv }}</td>
            <td>{{ v.addamount }}</td>
            <td>{{ v.addpv }}</td>
            <td>{{ $lt(initDict.yesno, v.isPre) }}</td>
          </tr>
          </tbody>
        </table>
        <!-- 当期订单信息 -->
        <table class="table-footer">
          <thead>
          <!-- 当期订单信息 -->
          <tr><th style="text-align: left" colspan="11">{{ $t('Current.order.information') }}</th></tr>
          <tr>
            <!-- 明细查看 -->
            <th>{{ $t('Detailed.view') }}</th>
            <!-- 期数 -->
            <th>{{ $t('common.periods') }}</th>
            <!-- 订单编号 -->
            <th>{{ $t('poOrder.orderNo') }}</th>
            <!-- 单据类型 -->
            <th>{{ $t('fiAcInput.orderType') }}</th>
            <!-- 代办处编号 -->
            <th>{{ $t('miAgent.agentNo') }}</th>
            <!-- F$ -->
            <th>{{ $t('F$') }}</th>
            <!-- PV -->
            <th>{{ $t('FV') }}</th>
            <!-- 换货积分 -->
            <th>{{ $t('BiGoods.proPv') }}</th>
            <!-- 支付方式 -->
            <th>{{ $t('poOrder.payWay') }}</th>
            <!-- 生成方式 -->
            <th>{{ $t('po.generateMethod') }}</th>
            <!-- 购买时间 -->
            <th>{{ $t('po.buyTime') }}</th>
          </tr>
          </thead>
          <tbody class="table-footer-td">
          <tr v-for="v in footerCenterList" :key="v.id">
            <!-- 查看明细按钮 -->
            <td><el-button circle size="mini" icon="el-icon-search" type="warning" :title="$t('Detailed.view')" @click="handleView(v)"/></td>
            <td>{{ v.periodWeek }}</td>
            <td>{{ v.orderNo }}</td>
            <td> {{ $lt(initDict.orderType, v.orderType) }}</td>
            <td>{{ v.agentNo }}</td>
            <td>{{ v.totalAmount }}</td>
            <td>{{ v.totalFv }}</td>
            <td>{{ v.totalpointa0 }}</td>
            <td>{{ $lt(initDict.paymentMethod, v.paymentMethod) }}</td>
            <td>{{ $lt(initDict.generateMethod, v.generateMethod) }}</td>
            <td>{{ v.checkTime }}</td>
          </tr>
          </tbody>
        </table>
        <!-- 当期奖金信息 -->
        <table class="table-footer">
          <thead>
          <tr>
            <th style="text-align: left" colspan="14">{{ $t('Current.bonus.information') }}</th>
          </tr>
          <tr>
            <!-- 期数 -->
            <th>{{ $t('common.periods') }}</th>
            <!-- 服务奖 -->
            <th>{{ $t('bd.bonusService') }}</th>
            <!-- 市场开拓奖 -->
            <th>{{ $t('bonus.bonusMarket') }}</th>
            <!-- 精英奖 -->
            <th>{{ $t('bd.eliteAward') }}</th>
            <!-- 钻石分红 -->
            <th>{{ $t('bd.share.diamond') }}</th>
            <!-- 旅游基金 -->
            <th>{{ $t('ac_type.B1') }}</th>
            <!-- 名车基金 -->
            <th>{{ $t('ac_type.B2') }}</th>
            <!-- 游艇基金 -->
            <th>{{ $t('ac_type.B3') }}</th>
            <!-- 豪宅基金 -->
            <th>{{ $t('fiawardtemp.bonustype.house') }}</th>
            <!-- 大使分红 -->
            <th>{{ $t('ac_type.S2') }}</th>
            <!-- 总奖金	 -->
            <th>{{ $t('bdBonus.bonusAll') }}</th>
            <!-- 税费 -->
            <th>{{ $t('bd.tax') }}</th>
            <!-- 奖金税费 -->
            <th>{{ $t('bd.taxBonus') }}</th>
            <!-- 实发 -->
            <th>{{ $t('bd.reality.send') }}</th>
          </tr>
          </thead>
          <tbody class="table-footer-td">
          <tr >
            <td>{{  this.tableObj.wWeek }}</td>
            <td>{{  this.tableObj.bonusService }}</td>
            <td>{{  this.tableObj.bonusMarket }}</td>
            <td>{{  this.tableObj.bonusCash }}</td>
            <td>{{  this.tableObj.bonusShare1 }}</td>
            <td>{{  this.tableObj.bonusFund1 }}</td>
            <td>{{  this.tableObj.bonusFund2 }}</td>
            <td>{{  this.tableObj.bonusFund3 }}</td>
            <td>{{  this.tableObj.bonusFund4 }}</td>
            <td>{{  this.tableObj.bonusShare2 }}</td>
            <td>{{  this.tableObj.bonusAll }}</td>
            <td>{{  this.tableObj.bonusTax }}</td>
            <td>{{  this.tableObj.taxBonus }}</td>
            <td>{{  this.tableObj.bonusFactSend }}</td>
          </tr>
          </tbody>
        </table>
        <p class="p-red">* The above bonus info is estimated for your reference and is subject to the actual bonus paid out which officially deposited into your e-wallet * </p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import {personAllInfo} from '@/api/ay-personal-center/personalcenter'

export default {
  name: "MeInfoInquire",
  data() {
    return {
      batchAmountObj: {},
      wWeekList: [],
      footerCenterList: [],
      footerTopList: [],
      tableObj: {},
      listView: [],
      formLoading: false,
      btnLoading: false,
      listQuery: {
        memberNo: '',
        wWeek: ''
      },
      initDict: {
        orderType: 'po.allordertype.cn',
        paymentMethod: 'poorder.paymentmethod',
        generateMethod: 'poorder.generatemethod',
        LevelType: 'cn.member.level',
        cardType: 'cn.mimember.cardtype',
        status: 'mi.active_num',
        yesno: 'yesno'
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode'
    ]),
    yesno() {
      return this.$ll(this.initDict.yesno)
    },
  },
  created() {
    this.listQuery.memberNo = this.userCode
    if(this.listQuery.wWeek){
      this.getList()
    }
  },
  mounted() {
    this.wWeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
    this.listQuery.wWeek = this.wWeekList[0].wWeek
  },
  methods: {
    getList() {
      this.formLoading = true
      this.btnLoading = true
      personAllInfo({ ...this.listQuery}).then(res => {
        this.tableObj = res.data.bdPersonalInformation[0] || { }
        this.tableObj.performanceIdAndPv = res.data.performanceIdAndPv
        this.tableObj.registerDate = this.tableObj.registerDate ?  this.tableObj.registerDate.slice(0, 10): ' '
        this.batchAmountObj = res.data.thisBatchAmount || { }
        this.footerTopList = res.data.thisMarketPerformances
        this.footerCenterList = res.data.thisOrderInfo
        this.formLoading = false
        this.btnLoading = false
      }).catch(err => {
        console.warn(err)
        this.formLoading = false
        this.btnLoading = false
      })
    },
    handleFilter() {
      this.getList()
    },
    handleView(row) {
      this.btnLoading = true
      this.$router.push({name: 'ViewOrderquery', params: {id: row.id}})
    }
  }
}
</script>

<style scoped lang="scss">
.meinfo-inquire {
  .table-top>table{
    border-collapse: collapse;
    margin: 10px;
  }
  .table-top-left {
    tr {
      th {
        width: 100px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: center;
        background: #fdddac;
      }
      td {
        width: 160px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: left;
        background: #fef2cc;
      }
    }
  }
  .table-top-center {
    tr {
      th {
        width: 100px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: center;
        background: #fdddac;
      }
      td {
        width: 100px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: left;
        background: #fef2cc;
      }
    }
  }
  .table-top-right {
    tr {
      th {
        width: 140px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: center;
        background: #fdddac;
      }
      td {
        width: 160px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: left;
        background: #fef2cc;
      }
      .th-two {
        width: 25px;
      }
    }
  }
  .table-footer {
    border-collapse: collapse;
    margin-top: 10px;
    tr {
      th {
        width: 150px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: center;
        background: #fdddac;
      }
      td {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border: 1px solid #ebab3a;
        text-align: left;
        background: #fef2cc;
      }
    }
    .table-footer-td {
      td {
        text-align: center;
      }
    }
  }
  .p-red {
    color: red;
    font-size: 1px;
    transform: scale(0.5);
    position: relative;
    left: -232px;
  }
}
</style>
